import { I18n } from '@front/volcanion'

class Callbacks {
  static onKeyDownHandler(dialogs, ctrlKeyMap, altKeyMap, baseKeyMap) {
    return function onKeyDown(e) {
      const { altKey, ctrlKey } = e
      if (!!e?.repeat || (!dialogs?.shortcuts_helper && !!_.some(dialogs, 'isOpen'))) return
      !!ctrlKey && ctrlKeyMap(e)
      !!altKey && altKeyMap(e)
      !altKey && !ctrlKey && baseKeyMap(e)
    }
  }
  static ctrlKeyMapHandler(record, extra, extraFunctions) {
    return async function ctrlKeyMap(event) {
      const { key } = event
      const { handleCancel, refuse, handleWaitingOrange, requestSubmit, handleOpenRedispatch, handleOpenClaimRedispatch, openNotification, openDialog } = extraFunctions
      const { isManagingBillingRecord, isManagingRecord, isEstimationLoading, canOrangeWait, canModify } = extra
      switch (key) {
        case 'F5':
          event.preventDefault()
          if (!isManagingRecord) return
          if (!canModify) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          handleOpenClaimRedispatch()
          break;
        case 'F6':
          event.preventDefault()
          if (!isManagingRecord) return
          if (!canModify) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          handleOpenRedispatch()
          break;
        case 'F8':
          event.preventDefault()
          if (!isManagingRecord) return
          if (!canModify) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          handleCancel()
          break;
        case 'F9':
          event.preventDefault()
          if (!canOrangeWait) return
          await handleWaitingOrange()
          break;
        case 'F12':
          event.preventDefault()
          if (!isManagingBillingRecord) return openNotification(I18n.t('toast.billing.error.wrong_mode'), { variant: 'error' })
          if (!canModify) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          refuse()
          break;
        case '²':
          event.preventDefault()
          !isEstimationLoading && requestSubmit({ disableRedirect: !!isManagingRecord, forceConfirmed: false })
          break;
        case 'Backspace':
          event.preventDefault()
          !isManagingRecord && openDialog('identifier_pin_form')
          break;
        case 'Enter':
        case 'ArrowRight':
          event.preventDefault()
          !isEstimationLoading && requestSubmit({ disableRedirect: key !== 'Enter' || !!isManagingRecord, forceConfirmed: true })
          break;
        default:
          return false
      }
    }
  }
  static altKeyMapHandler(record, extra, extraFunctions) {
    return async function altKeyMap(event) {
      const { key } = event
      const { handleOpenSendMessageDriver, handleChangeIsB2B, openNotification } = extraFunctions
      const {
        isManagingRecord,
        isReadOnly,
        gsm,
        operator,
        canModify,
        canSendMessage,
        canDisplayIncidents,
        canDisplayDispatch,
        canDisplayDriver
      } = extra
      const driver_id = _.get(record, 'assigned_transport.driver.user_id')

      switch (key) {
        case 'F2':
          event.preventDefault()
          if (!operator) return
          window.open(`/order?operator_id=${_.get(operator, 'user_id')}`, '_blank')
          break;
        case 'F3':
          event.preventDefault()
          if (!gsm) return
          window.open(`/order?client_phone=${_.replace(gsm, '+', '')}`, '_blank')
          break;
        case 'F5':
          event.preventDefault()
          window.open('/order', '_blank').focus()
          break;
        case 'F6':
          event.preventDefault()
          if (!canDisplayDispatch) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          window.open('/dispatch', '_blank').focus()
          break;
        case 'F9':
          event.preventDefault()
          if (!driver_id) return
          window.open(`/order?driver_id=${driver_id}`, '_blank')
          break;
        case 'F10':
          event.preventDefault()
          if (!driver_id) return
          if (!canDisplayDriver) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          window.open(`/driver?user_id=${driver_id}`, '_blank')
          break;
        case 'F11':
          event.preventDefault()
          if (!isManagingRecord || !driver_id) return
          if (!canSendMessage) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          handleOpenSendMessageDriver()
          break;
        case 'F12':
          event.preventDefault()
          if (!canDisplayIncidents) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          window.open('/incident', '_blank').focus()
          break;
        case 'Enter':
          event.preventDefault()
          if (!!isReadOnly) return
          if (!canModify) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          handleChangeIsB2B()
          break;
        default:
      }
    }
  }
  static baseKeyMapHandler(record, extra, extraFunctions) {
    return async function baseKeyMap(event) {
      const { key } = event
      const { setFormState, navigate, handleOpenSendCommentDialog, handleOpenManualDispatch, handleCall, approve, handleClickMap, handleOpenShortcut, openNotification } = extraFunctions
      const {
        isManagingRecord,
        isManagingBillingRecord,
        isMapOpen,
        isReadOnly,
        driver_number,
        customer_number,
        focusedField,
        companycontract,
        companyservice,
        canModify,
        canCreate
      } = extra
      switch (key) {
        case 'Tab':
          if (
            (_.get(focusedField, 'field') === 'user.companycontract' && !companycontract) ||
            (_.get(focusedField, 'field') === 'user.companyservice' && !companyservice)
          )
            event.preventDefault()
          break;
        case 'F1':
          event.preventDefault()
          handleOpenShortcut()
          break;
        case 'F2':
          event.preventDefault()
          if (!isManagingRecord) return
          if (!canModify) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          handleOpenSendCommentDialog()
          break;
        case 'F5':
          event.preventDefault()
          handleClickMap(isMapOpen)
          break;
        case 'F6':
          event.preventDefault()
          if (!isManagingRecord) return
          if (!canModify) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          handleOpenManualDispatch()
          break;
        case 'F7':
          event.preventDefault()
          await handleCall(driver_number)
          break;
        case 'F8':
          event.preventDefault()
          if (!isManagingRecord) return
          if (!canModify) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          setFormState({ isReadOnly: false })
          break;
        case 'F9':
          event.preventDefault()
          await handleCall(customer_number)
          break;
        case 'F12':
          if (!isManagingBillingRecord) return openNotification(I18n.t('toast.billing.error.wrong_mode'), { variant: 'error' })
          if (!canModify) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          approve()
          break;
        case 'Enter':
          event.preventDefault()
          if (!isManagingRecord || !isReadOnly) return
          if (!canCreate) {
            openNotification(I18n.t('action.denied'), { variant: 'error' })
            return
          }
          navigate('/order/create')
          break;
        case 'Escape':
          if (!isManagingRecord || !!isReadOnly) return
          setFormState({ isReadOnly: true })
          break;
        default:
      }
    }
  }
}

export default Callbacks
